import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Appointment } from '../../models/appointment.model';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-appointment-confirmation-modal',
  templateUrl: './booking-success.modal.html',
  styleUrls: ['./booking-success.modal.scss'],
  imports: [DatePipe],
})
export class BookingSuccessModal {
  booking: Appointment | undefined;
  isOpen: true | undefined;

  constructor(
    public dialogRef: MatDialogRef<BookingSuccessModal>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    // Initialize properties with data passed to the modal
    this.booking = data.appointment || null;
  }

  closeModal(): void {
    this.dialogRef.close(); // Close the dialog
  }
}
